import { useParams, Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';

export default function FeaturedArticle() {
  const { slug } = useParams<{ slug: string }>();
  const categoryArticles = newsArticles.filter((a) => a.categorySlug === slug);
  const featured = categoryArticles.find((a) => a.isFeatured) || categoryArticles[0];

  if (!featured) return null;

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="relative bg-background-200/60 rounded-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-[45%] relative -ml-0 lg:-ml-10 my-0 lg:my-8">
                <div className="h-64 lg:h-full min-h-[320px] overflow-hidden rounded-xl">
                  <img
                    src={featured.coverImage}
                    alt={featured.title}
                    title={`${featured.title} - 51黑料吃瓜网 主编精选`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="lg:w-[55%] flex flex-col justify-center p-8 lg:p-12">
                <div className="text-foreground-500/30 font-heading text-6xl md:text-8xl leading-none mb-4 select-none">
                  &ldquo;
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 leading-snug mb-4">
                  {featured.title}
                </h3>
                <p className="text-foreground-400 text-sm leading-relaxed mb-6">
                  {featured.excerpt}
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                    <span className="text-foreground-950 text-xs font-bold">
                      {featured.author.slice(0, 1)}
                    </span>
                  </div>
                  <div>
                    <p className="text-foreground-600 text-sm font-medium">{featured.author}</p>
                    <p className="text-foreground-300 text-xs">{featured.date}</p>
                  </div>
                </div>
                <Link
                  to={`/detail/${featured.id}`}
                  className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-500 text-foreground-950 text-sm font-medium rounded-full hover:bg-secondary-400 transition-all duration-300 whitespace-nowrap cursor-pointer w-fit"
                >
                  阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}